import ColorPickerModal from "../../src/js/components/color-picker-modal";

class TextImageModal {
  constructor() {
    new ColorPickerModal();
  }
}

new TextImageModal();
